import React, { Component, Fragment } from "react";
import Field from "../../components/Common/Field/Field";
import download from "../../assets/images/download.png";
import pdfDownload from "../../assets/images/printer.png";
import { connect } from "react-redux";
import moment from "moment";
import Modal from "react-responsive-modal";
import AlertContainer from "react-alert";
import ReactToPrint from "react-to-print";

//service
import {
  CustomerServices,
  UtilityService,
  ReportServices,
  DevelopmentServices,
  SampleServices,
  StyleServices,
  PermissionServices
} from "../../services";
import {
  Dispatch,
  CustOutstand,
  BNumberList,
  ProcessCompletedList,
  PrintYarnList,
  ProcessUpdatesList,
  FabricPricePendingList,
  FabricLibraryList,
  SampleLibraryList,
  SampleReportByProcessesList,
  PatterMasterReportList,
  StyleDownloadsList
} from "../../components/Report/reports";
import Loading from "../../components/Common/Loading";
import options from "../../services/common/options";
import {
  FabricForm,
  CustOutstandingForm,
  FabricPricePending,
  FabricLibrary,
  DispatchForm,
  BNumberForm,
  ProcessCompletedForm,
  PrintYarnForm,
  ProcessUpdatesForm,
  SampleLibrary,
  SampleReportByProcessesForm,
  BulkUpdateForDispatch,
  PatterMasterReport,
  BulkProcessUpdates,
  StyleDownloads
} from "../../components/Report/forms";

import PrintTable from "./print"

const { processTypeoptions } = options;
let isOther = (type) => {
  switch (type) {
    case 'sampleProcesses':
      return false
    case 'custDept':
      return false
    default:
      return true
  }
}

const statusOptions = [
  { value: "CANCEL", label: "Cancelled" },
  { value: "COMPLETED", label: "Completed" },
  { value: "PENDING", label: "Pending" },
  { value: "IN PROCESS", label: "In Process" }
];
const progressOptions = [
  { value: "ALL", label: "All" },
  { value: "COMPLETED", label: "Completed" },
  { value: "NOTCOMPLETED", label: "Not Completed" },
];

class Report extends Component {
  customerChoosen = "";
  state = {
    processUpdatesETA: "",
    filePreviewIframe: "",
    bNumber: "",
    countCons: "",
    processType: "",
    processTypeOptions: processTypeoptions,
    header: {},
    body: [],
    type: "",
    reportType: "",
    fabricReportList: [],
    reportTypeOption: [],
    customerOption: [],
    customerList: [],
    ids: [],
    NumberFromList: [],
    NumberFromObj: "",
    NumberToObj: "",
    supplierOption: [],
    sampleTypeOptions: [],
    supplierName: null,
    requirementOption: [],
    printDate: '',
    List: [],
    emailId: "",
    currentDiv: "",
    status: null,
    progress: null,
    requirement: null,
    customerWithDept: [],
    hasMore: true,
    isLoading: false,
    imagecount: 0,
    count: 0,
    generateCount: 0,
    page: 1,
    rights: {},
    sampleType: null,
    typeOfRequest: null,
    image: false,
    fromDate: null,
    toDate: null,
    createdAt: null,
    completed: null,
    styleNo: null,
    styleName: null,
    styleType: "styleNo",
    styleTypeValue: "",
    garmentType: null,
    itemNo: "",
    imageType: null,
    location: null,
    courier: null,
    customerRefNo: "",
    actionedBy: "",
    openModal: false,
    arrayValue: [],
    arrayValue1: [],
    arrayValue2: [],
    userPageInput: 1,
    scroll: true,
    patterMasterList: [],
    patternMaster: null,
    requestKey: "status",
    requestValue: "",
    STATUS: [],
    showForm: true,
    all: false,
    sortIn: 0,
    sortField:null,
    sortDirection:null,
    prevReportType: null,
    prevProcessType: null,
  };

  alertOptions = {
    offset: 65,
    position: "top left",
    theme: "dark",
    time: 1000,
    transition: "scale"
  };

  componentWillMount() {
    setTimeout(() => {
      let reportTypeOption = [{
        label: "BNumber Report",
        value: "bNumber",
        disabled: this.props.rights.bNumber.web.view
      },
      {
        label: "Bulk Updates For Dispatch",
        value: "bulkUpdateDispatch",
        disabled: this.props.rights.bulkUpdateDispatch.web.view
      },
      {
        label: "Dispatch Report",
        value: "dispatch",
        disabled: this.props.rights.dispatch.web.view
      },
      {
        label: "Fabric Library",
        value: "fabricLibrary",
        disabled: this.props.rights.fabricLibrary.web.view
      },
      {
        label: "Fabric Price Pending",
        value: "fabPricePending",
        disabled: this.props.rights.fabPricePending.web.view
      },
      {
        label: "Fabric Report",
        value: "fabric",
        disabled: this.props.rights.fabric.web.view
      },
      {
        label: "Outstanding Customer",
        value: "custDept",
        disabled: this.props.rights.outstandingCustomer.web.view
      },
      {
        label: "Pattern Master Report",
        value: "patternMasterReport",
        disabled: this.props.rights.patternMasterReport.web.view
      },
      {
        label: "Process Completed",
        value: "processCompleted",
        disabled: this.props.rights.processCompleted.web.view
      },
      {
        label: "Process Updates",
        value: "bulkUpdateProcess",
        disabled: this.props.rights.bulkUpdateProcess.web.view
      },
      {
        label: "Samples Awaiting Materials",
        value: "processUpdates",
        disabled: this.props.rights.processUpdates.web.view
      },
      {
        label: "Sample Library",
        value: "sampleLibrary",
        disabled: this.props.rights.sampleLibrary.web.view

      },
      {
        label: "Sample Report By Processes",
        value: "sampleProcesses",
        disabled: this.props.rights.sampleProcesses.web.view

      },
      {
        label: "Sample Request Downloads",
        value: "sampleRequestDownloads",
        // disabled: this.props.rights.sampleProcesses.web.view

      },
      {
        label: "Style Downloads",
        value: "styleDownloads",
        disabled: this.props.rights.processUpdates.web.view
      },
      ];
      // console.log(this.props.rights, "this.props.rights");

      // reportTypeOption.forEach((x)=>{
      //   console.log(this.props.rights[x.value], x);

      // })
      reportTypeOption = reportTypeOption.filter((y) => {
        let name = y.value === 'custDept' && 'outstandingCustomer' || y.value
        return this.props.rights[name] && this.props.rights[name].web.view
      })

      this.setState({
        reportTypeOption
      });
    }, 400);
  }

  componentDidMount() {
    //sampleNo
    SampleServices.getSampleReqNo("")
      .then(response => {
        if (response.status === 200) {
          this.setState({
            NumberFromList: response.text.data,
            // isLoading: true
          })
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))

    //customer
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          let customerOption = [
            ...new Set(response.text.data.map(x => x.customerName))
          ];
          this.setState({
            customerList: [...response.text.data],
            customerOption
          });
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));

    CustomerServices.customerWithDepartmentInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState({ customerWithDepartment: response.text.data });
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));

    //get fabric section from system
    // DevelopmentServices.prefillFabricDetails()
    //   .then(response => {
    //     this.setState({
    //       supplierOption: response.data.Fabric.SUPPLIERNAME,
    //       requirementOption: response.data.Fabric.REQUIREMENT
    //     });
    //   })
    //   .catch(error => this.props.getalertMessage("error", error.toString()));

    SampleServices.prefillSRDetails().then(res => {
      if (res.message === "Operation Successful") {
        this.setState({
          COURIER: res.data.SYSTEMSAMPLEREQUEST.COURIER,
          LOCATION: res.data.SYSTEMSAMPLEREQUEST.LOCATION,
          fabQualityList: res.data.FABRIC.BASICQUALITY
        });
      }
    });

    setTimeout(() => {
      this.setState({ oldState: this.state })
    }, 1000)

  }

  componentDidUpdate(prevProps, prevState) {
    const { reportType, processType } = this.state;
  
    // Check if reportType or processType has changed
    if (prevState.reportType !== reportType || prevState.processType !== processType) {
      // Reset sortField and sortDirection on type change
      this.setState({
        sortField: null,
        sortDirection: null
      });
    }
  }
  

  getNumberList = e => {
    SampleServices.getSampleReqNo(e)
      .then(response => {
        if (response.status == 200) {
          this.setState({
            NumberFromList: response.text.data,
            // isLoading: true
          })
        }
      })
      .catch(error => {
        // UtilityService.errorMsg(this.msg);
      })
  }

  updateReportType = (name, value) => {
    if (value != "") {
      let oldState = { ...this.state.oldState }
      this.setState({ ...oldState, [name]: value });
      let arr = ["custDept", "dispatch", "fabPricePending", "fabricLibrary", "sampleLibrary", "sampleProcesses", "bulkUpdateDispatch", "processUpdates", "processCompleted", "patternMasterReport", "bulkUpdateProcess", "styleDownloads", "sampleRequestDownloads"]
      if (arr.includes(value)) {
        // value === "custDept" || value === "dispatch"
        setTimeout(() => {
          ReportServices.getSampleType()
            .then(res => {
              if (res.status == 200) {
                this.setState({
                  fromDate: moment()
                    .subtract(6, "months")
                    .format("DD MMM YYYY"),
                  // toDate: new Date(),
                  sampleTypeOptions: res.text.data.SAMPLETYPE,
                  STATUS: res.text.data.STATUS,
                  patterMasterList: res.text.data.patternMaster
                });
              }
            })
            .catch(error =>
              this.props.getalertMessage("error", error.toString())
            );
        }, 500);
        if (value === "sampleLibrary" || value === "styleDownloads") {
          StyleServices.getStylePrefilledData().then((res) => {
            this.setState({
              garmentTypeOptions: res.text.data.GARMENTTYPE,
              actionedByOptions: res.text.data.ACTIONEDBY,
            })
          })
          if (value === "sampleLibrary")
            UtilityService.getImageType().then((res) => {
              this.setState({
                imageTypeOptions: res.text.data
              })
            })
        }
      } else if (value === "fabric") {
        this.setState({
          isLoading: true
        });
        //get fabric section from system
        DevelopmentServices.prefillFabricDetails()
          .then(response => {
            this.setState({
              supplierOption: response.data.Fabric.SUPPLIERNAME,
              requirementOption: response.data.Fabric.REQUIREMENT,
              isLoading: false
            });
          })
          .catch(error => this.props.getalertMessage("error", error.toString()));
      }

    } else {
      this.setState({ [name]: null });
    }
    this.customerChoosen = "";
    this.setState({ body: [], fabricReportList: [] });
  };

  exportReport = async (reportType, page,sortBy, sortOrder) => {
    let objData = {
      submitReport: true,
      isLoading: true
      // fabricReportList: []
    }
    if (page === 1) {
      objData = {
        ...objData,
        generateCount: page,
        userPageInput: page
      }
    }
    this.setState(objData);

    // const adjustedSortBy = sortBy === "ETA/ETD" ? "ETA" : sortBy;

    let filter = {
      customerDepartList: this.customerChoosen,
      supplier: this.state.supplierName ? this.state.supplierName.value : null,
      requirement: this.state.requirement,
      status: this.state.status,
      progress: this.state.progress,
      reportType: this.state.type === "bulkUpdateProcess" ? "processUpdates" : this.state.type,
      isExport:
        reportType === "sendEmail" ? false : reportType === true ? true : false,
      sendMail: reportType === "sendEmail" ? true : false,
      emailId: this.state.emailId.trim(),
      page: page,
      // sortField: adjustedSortBy,
      // sortDirection: sortOrder
    };
    // Include sorting fields only for 'bulkUpdateProcess' and 'processUpdates'
    if (["bulkUpdateProcess", "processUpdates"].includes(reportType)) {
      filter.sortField = sortBy;
      filter.sortDirection = sortOrder;
    }

    switch (this.state.type) {
      case 'custDept':
        filter.withImage = Boolean(this.state.image);
        filter.typeOfRequest = this.state.typeOfRequest;
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue.length > 0 
        ? this.state.arrayValue.map(x => x.value) 
        : null;
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        filter.createdAt = this.state.createdAt;
        break;
      case 'dispatch':
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue2.length > 0 
        ? this.state.arrayValue2.map(x => x.value) 
        : null;
        filter.location = this.state.location;
        filter.courier = this.state.courigenerateer;
        filter.awbNumber = this.state.awbNumber;
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        break;
      case 'fabPricePending':
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue.length > 0 
        ? this.state.arrayValue.map(x => x.value) 
        : null;
        filter.typeOfRequest = this.state.typeOfRequest;
        break;
      case 'fabricLibrary':
        filter.sampleType = this.state.sampleType;
        filter.fabNumber = this.state.fabNumber;
        filter.toDate = this.state.toDate;
        filter.quality = this.state.quality
        filter.fromDate = this.state.fromDate;
        filter.countCons = this.state.countCons;
        break;
      case 'sampleProcesses':
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue2.length > 0 
        ? this.state.arrayValue2.map(x => x.value) 
        : null;
        filter.fabNumber = this.state.fabNumber;
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        filter.typeOfRequest = this.state.typeOfRequest;
        filter.headers = [...this.state.arrayValue1].map(x => x.label === "3D" && "CAD" || x.label.toUpperCase())
        filter.processes = [...[...this.state.arrayValue].map(x => x.value), { headers: [...this.state.arrayValue1].map(x => x.value) }]
        // filter.processes = [...this.state.arrayValue].map(x => x.value)
        if (!filter.headers.length || !filter.processes.length) {
          this.props.getalertMessage('info', "Please select mandatory fields")
          this.setState({
            isLoading: false
          });
          return
        }
        break;
      case "sampleLibrary":
        filter.styleType = this.state.styleType;
        let styleRes = this.state.styleType;
        let styleResVal = this.state.styleTypeValue;
        filter.styleNo = 'styleNo' === styleRes ? styleResVal : this.state.styleNo
        filter.styleName = 'styleName' === styleRes ? styleResVal : this.state.styleName
        filter.styleTypeValue = this.state.styleTypeValue;
        filter.garmentType = this.state.garmentType;
        filter.imageType = this.state.imageType;
        filter.itemNo = this.state.itemNo;
        filter.customerRefNo = this.state.customerRefNo;
        filter.actionedBy = this.state.actionedBy;
        break;
      case 'bNumber':
        filter.bNumber = this.state.bNumber;
        filter.countCons = this.state.countCons;
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        break;
      case 'processCompleted':
        filter.processType = this.state.processType;
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue2.length > 0 
        ? this.state.arrayValue2.map(x => x.value) 
        : null;
        filter.typeOfRequest = this.state.typeOfRequest;
        filter.completed = this.state.completed;
        break;
      case 'bulkUpdateDispatch':
        filter = {}
        filter.reportType = "bulkUpdateDispatch"
        filter.isExport = false
        filter.ids = this.state.ids.map(x => x.value)
        break;
      case 'processUpdates':
        filter.processType = this.state.processType;
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue2.length > 0 
        ? this.state.arrayValue2.map(x => x.value) 
        : null;
        filter.typeOfRequest = this.state.typeOfRequest;
        filter.eta = this.state.processUpdatesETA;
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        break;
      case 'bulkUpdateProcess':
        filter.processType = this.state.processType;
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue2.length > 0 
        ? this.state.arrayValue2.map(x => x.value) 
        : null;
        filter.typeOfRequest = this.state.typeOfRequest;
        filter.eta = this.state.processUpdatesETA;
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        break;
      case 'patternMasterReport':
        //filter.sampleType = this.state.sampleType;
        filter.sampleType = this.state.arrayValue2.length > 0 
        ? this.state.arrayValue2.map(x => x.value) 
        : null;
        filter.typeOfRequest = this.state.typeOfRequest;
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        filter.patternMasterId = this.state.patternMaster ? this.state.patternMaster.value : null
        break;
      case 'styleDownloads':
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        filter.actionedBy = this.state.actionedBy
        break;
      case 'sampleRequestDownloads':
        filter.toDate = this.state.toDate;
        filter.fromDate = this.state.fromDate;
        break;
    }

    await ReportServices.getReport(filter)
      .then(async response => {
        if (response.status === 200) {
          if (filter.sendMail) {
            await this.props.getalertMessage("success", response.text.data);
          } else if (filter.isExport) {
            await this.downloadReport(response.text.data);
          } else if (!filter.isExport && isOther(this.state.type)) {
            if (this.state.type === 'sampleLibrary') {
              console.log("SampleLibrary Data");
              await this.setState(
                {
                  fabricReportList: [],
                  count: response.text.data.count,
                  // hasMore:
                  //   response.text.data.count < 100 ||
                  //     page * 100 >= response.text.data.count
                  //     ? false
                  //     : true,
                  page: page,
                  generateCount: this.state.generateCount,
                  header: {},
                  body: []
                  // image: this.state.type === 'fabric' ? true : false
                },
                () => this.setState({
                  fabricReportList: response.text.data.tableList,
                })
              );
            } else {
              await this.setState(
                {
                  showForm: false,
                  fabricReportList: (page != 1 && [
                    ...this.state.fabricReportList,
                    ...response.text.data.tableList
                  ]) || [...response.text.data.tableList],
                  count: response.text.data.count,
                  hasMore:
                    response.text.data.count < 100 ||
                      page * 100 >= response.text.data.count
                      ? false
                      : true,
                  page: page,
                  generateCount: this.state.generateCount + 1,
                  header: {},
                  body: []
                  // image: this.state.type === 'fabric' ? true : false
                },
                () => this.scrollToTable()
              );
            }
          } else if (this.state.type === "custDept" || this.state.type === "sampleProcesses") {
            let header = { ...this.state.header };
            if (page === 1 && response.text.data.tableList.length) {
              header.h1 = "CUSTOMER";
              header.h2 = Object.keys(response.text.data.tableList[0].data[0]);
            }
            this.setState(
              {
                header,
                body: (page != 1 && [
                  ...this.state.body,
                  ...response.text.data.tableList
                ]) || [...response.text.data.tableList],
                count: response.text.data.count,
                hasMore:
                  response.text.data.count < 100 ||
                    page * 100 >= response.text.data.count
                    ? false
                    : true,
                page: page,
                generateCount: this.state.generateCount + 1
              },
              () => this.scrollToTable()
            );
          }
        } else {
          UtilityService.errorMsg(this.msg, response.text.message, 1500);
          // console.log(response.text, "responseresponse");
        }
        await this.setState({
          isLoading: false
        });
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));
    return true
  };

  downloadReport = data => {
    var anchor = document.createElement("a");
    anchor.href = UtilityService.baseUrl() + data.link;
    anchor.target = "_blank";
    anchor.download = UtilityService.baseUrl() + data.link;
    anchor.click();
  };

  changeSupplierInfo = supplierName => {
    supplierName !== null
      ? this.setState({ supplierName })
      : this.setState({ supplierName: null });
  };

  storeCustomerData = (currentNode, selectedNodes) => {
    this.customerChoosen = selectedNodes;
  };

  // handleScroll = async e => {
  //   if (this.state.type !== 'sampleLibrary') {
  //     let length = this.state.fabricReportList.length || this.state.body.length;
  //     if (this.state.count !== length) {
  //       // const bottom = e.target.scrollHeight - e.target.scrollTop === (e.target.clientHeight+40);
  //       const bottom = e.target.scrollHeight <= ((e.target.scrollTop + 40) + e.target.clientHeight);
  //       console.log(bottom, "bottom");
  //       if (bottom && this.state.scroll) {
  //         let page = (this.state.page % length) + 1;
  //         this.setState({
  //           scroll: false,
  //           generateCount: 0
  //         });
  //         if (isOther(this.state.type)) {
  //           this.setState({
  //             scroll: await this.exportReport(false, page)
  //           });
  //         }
  //       }
  //     }
  //   }
  // };


  // handleScroll = async (e) => {
  //   if (this.state.type !== 'sampleLibrary') {
  //     const length = this.state.fabricReportList.length || this.state.body.length;
  //     if (this.state.count !== length) {
  //       const bottom = e.target.scrollHeight <= (e.target.scrollTop + e.target.clientHeight + 40);
  //       if (bottom && this.state.scroll) {
  //         const nextPage = this.state.page + 1;
  //         this.setState({ scroll: false, page: nextPage });
          
  //         // Trigger exportReport with current sort values for the next page
  //         await this.exportReport(this.state.type, nextPage, this.state.sortBy, this.state.sortOrder);
          
  //         // Re-enable scrolling for further data loading
  //         this.setState({ scroll: true });
  //       }
  //     }
  //   }
  // };


  handleScroll = async (e) => {
    //console.log(this.state.type,"type")
    if (this.state.type !== 'sampleLibrary' && this.state.type !=='custDept' && this.state.type !== 'fabPricePending' && this.state.type !== 'sampleProcesses' && this.state.type !== 'dispatch') {
        const length = this.state.fabricReportList.length || this.state.body.length;
        //console.log(length, "length");
        if (this.state.count !== length) {
            const bottom = e.target.scrollHeight <= (e.target.scrollTop + e.target.clientHeight + 40);
            if (bottom && this.state.scroll) {
                const nextPage = this.state.page + 1;
                this.setState({ scroll: false, page: nextPage });

                // Pass the current sortField and sortDirection to exportReport
                await this.exportReport(
                    this.state.type, 
                    nextPage, 
                    this.state.sortField, 
                    this.state.sortDirection
                );

                // Re-enable scrolling for further data loading
                this.setState({ scroll: true });
            }
        }
    }else if (this.state.type === 'custDept' || this.state.type === 'fabPricePending' || this.state.type === 'sampleProcesses' || this.state.type === 'dispatch') {
      let length = this.state.fabricReportList.length || this.state.body.length;
      if (this.state.count !== length) {
        // const bottom = e.target.scrollHeight - e.target.scrollTop === (e.target.clientHeight+40);
        const bottom = e.target.scrollHeight <= ((e.target.scrollTop + 40) + e.target.clientHeight);
        console.log(bottom, "bottom");
        if (bottom && this.state.scroll) {
          let page = (this.state.page % length) + 1;
          this.setState({
            scroll: false,
            generateCount: 0
          });
          if (isOther(this.state.type)) {
            this.setState({
              scroll: await this.exportReport(false, page)
            });
          }
        }
      }
    }
};

  generatePage = async (page) => {
    this.setState({
      generateCount: page,
      userPageInput: page === 0 ? 1 : page
    });
    page = page === 1 ? page + 1 : (page || 1)
    await this.exportReport(false, page);
  }

  scrollToTable = () => {
    var ele = document.getElementById("report-list-height");
    ele.scrollIntoView();
  };

  updateSampleType = e => {
    let { name, value } = e.target;
    this.setState({
      typeOfRequest: value
    });
  };

  updateRequest = e => {
    let { name, value } = e.target;
    this.setState({
      typeOfRequest: value
    });
  };

  updateState = (name, value, reset = true, key) => {
    if (this.state[name] === value) {
      if (value !== "") {
        this.setState({ [name]: value });
      } else {
        this.setState({ [name]: null });
      }
    } else {
      if (value !== "") {
        if (reset)
          this.setState({
            [name]: value,
            header: {},
            body: [],
            fabricReportList: []
          });
        else
          this.setState({
            [name]: value,
            [key]: ""
          });
      } else {
        this.setState({ [name]: null });
      }
    }
  };



  addNumbers = () => {
    let { ids, NumberFromObj } = { ...this.state }
    if (NumberFromObj !== "") {
      let obj = ids.find(x => x.value === NumberFromObj.value)
      if (!obj) {
        ids = [...ids, NumberFromObj]
        this.setState({ ids, selectedNumberObj: NumberFromObj.value, NumberFromObj: '' })
      } else {
        this.setState({ NumberFromObj: '' })
        this.props.getalertMessage('info', 'SR Number already added in list')
      }
    }
  }

  selectMultipleOption = (value) => {
    this.setState({ arrayValue1: value });
  }
  selectMultipleOption1 = (value) => {
    this.setState({ arrayValue: value });
  }
  selectMultipleOption2 = (value) => {
    this.setState({ arrayValue2: value });
  }

  displayData = index => {
    let fabricReportList = [...this.state.fabricReportList];
    fabricReportList.map((x, i) => {
      if (i == index) {
        x.disable = !x.disable;
      }
    });
    this.setState({ fabricReportList });
  };

  modalData = data => {
    let filePreviewIframe = this.state.filePreviewIframe;
    filePreviewIframe = <img src={data} />;
    this.setState({ filePreviewIframe, openModal: true });
  };



  removeNumbers = (value) => {
    // var selected = document.getElementById("mySelectNum").value
    let { ids, NumberFromObj } = { ...this.state }
    if (value && ids && ids.length) {
      ids = ids.filter(x => x.value != value)
      this.setState({ ids })
    } else {
      this.props.getalertMessage('info', "Select SR Number")
    }
  }

  resetBy = () => {
    this.setState({ ids: [], List: [], fabricReportList: [] })
  }

  getNumberFrom = (fabricNum) => {
    if (fabricNum) {
      this.setState({
        NumberFrom: fabricNum.value,
        NumberFromObj: fabricNum
      })
    } else {
      this.setState({
        NumberFrom: "",
        NumberFromObj: ""
      })
      //   this.getFabricNumber("")
    }
  }

  bulkDispatchUpdate = (date, awbNumber, location, courier) => {
    if (!awbNumber || !location || !courier || !this.state.ids.length) {
      this.props.getalertMessage("info", "Please fill all valid data")
    } else {
      let obj = { date: !date && new Date() || date, awbNumber, location, courier }
      let list = [...this.state.fabricReportList]
      list = list.reduce((pv, cv, i) => {
        let objD = {}
        objD._id = cv.id
        objD.dispatch = [{
          size: cv.selectedSize,
          quantity: cv.selectedQty,
          ...obj
        }]
        if (pv.some(e => (e._id === cv.id))) {
          pv.map(x => {
            if (x._id === cv.id) {
              x.dispatch = [...x.dispatch, ...objD.dispatch]
            }
          })
        } else {
          pv.push(objD)
        }
        return pv
      }, [])
      SampleServices.bulkUpdateDispatch({ data: list }).then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", response.message)
        }
        response.status == 401 && this.props.unauthorisedFunc()
        response.status == 400 && this.props.getalertMessage("error", response.text.message)
      })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }

  }

  addDispatchData = (data, index) => {
    let { fabricReportList } = this.state
    let indexData = { ...fabricReportList[index], ['SIZE']: data, selectedSize: "", selectedQty: "" }
    fabricReportList = fabricReportList.splice(index, 0, indexData)
    this.setState(fabricReportList)
  }

  dispatchUpdate = (value, index, key) => {
    let { fabricReportList } = this.state
    fabricReportList[index][key] = value
    // fabricReportList = fabricReportList.splice(index, 0, indexData)
    this.setState(fabricReportList)
  }

  sorting = (key) => {
    let { fabricReportList, sortIn } = this.state
    if (key === "SR NO") {
      fabricReportList = fabricReportList.sort((a, b) => sortIn && (a[key].number.toLowerCase() > b[key].number.toLowerCase() && 1 || -1) || a[key].number.toLowerCase() > b[key].number.toLowerCase() ? -1 : 1)
    } else if (key === "STYLE NO") {
      fabricReportList = fabricReportList.sort((a, b) => sortIn && (a[key].code.toLowerCase() > b[key].code.toLowerCase() && 1 || -1) || a[key].code.toLowerCase() > b[key].code.toLowerCase() ? -1 : 1)
    } else if (key === "ETA/ETD") {
      //fabricReportList = fabricReportList.sort((a, b) => sortIn ? moment(a[key], "DD MMM YYYY").valueOf() - moment(b[key], "DD MMM YYYY").valueOf() ? 1 : -1 : moment(a[key], "DD MMM YYYY").valueOf() - moment(b[key], "DD MMM YYYY").valueOf() ? -1 : 1)
      fabricReportList = fabricReportList.sort((a, b) => {
        const dateA = a[key] ? moment(a[key], "DD MMM YYYY").valueOf() : (sortIn ? Number.MAX_SAFE_INTEGER : 0);
        const dateB = b[key] ? moment(b[key], "DD MMM YYYY").valueOf() : (sortIn ? Number.MAX_SAFE_INTEGER : 0);
        
        if (dateA === dateB) return 0; // Handles cases where both dates are empty or identical
        return sortIn ? (dateA - dateB) : (dateB - dateA);
      });
    } else if(key === "FABRIC ETA"){
      fabricReportList = fabricReportList.sort((a, b) => {
        const dateA = a[key] ? moment(a[key], "DD MMM YYYY").valueOf() : (sortIn ? Number.MAX_SAFE_INTEGER : 0);
        const dateB = b[key] ? moment(b[key], "DD MMM YYYY").valueOf() : (sortIn ? Number.MAX_SAFE_INTEGER : 0);
        
        if (dateA === dateB) return 0; // Handles cases where both dates are empty or identical
        return sortIn ? (dateA - dateB) : (dateB - dateA);
      });
    } else if (key === "DATE OF REQUEST") {
      fabricReportList = fabricReportList.map(x => ({ ...x, [key]: moment(x[key].trim(), "DD MMM YYYY").valueOf() })).sort((a, b) => {
        return sortIn ? b[key] - a[key] : a[key] - b[key]
      }).map(x => ({ ...x, [key]: moment(x[key]).format("DD MMM YYYY") }))
    } else {
      fabricReportList = fabricReportList.sort((a, b) => sortIn ? a[key].toLowerCase() > b[key].toLowerCase() ? 1 : -1 : a[key].toLowerCase() > b[key].toLowerCase() ? -1 : 1)
    }
    this.setState({ fabricReportList, sortIn: sortIn ? 0 : 1 })
  }

  // handleSorting = (field) => {
  //   const sortOrder = this.state.sortBy === field && this.state.sortOrder === "asc" ? "desc" : "asc";
  //   this.setState({ sortBy: field, sortOrder }, () => {
  //     // Only fetch sorted data from backend for specific report types
  //     if (["bulkUpdateProcess", "processUpdates"].includes(this.state.type)) {
  //       this.exportReport(this.state.type, 1, field, sortOrder);
  //     }
  //   });
  // };

//   handleSorting = (field) => {
//     const { sortField, sortDirection, reportType, processType } = this.state;

//     // Reset sortDirection to 'asc' if reportType or processType changed; otherwise, toggle
//     const newSortDirection = (reportType !== this.state.prevReportType || processType !== this.state.prevProcessType) 
//         ? 'asc' 
//         : (sortField === field && sortDirection === 'asc' ? 'desc' : 'asc');

//     this.state.prevReportType = reportType;
//     this.state.prevProcessType = processType;

//     this.setState(
//         { sortField: field, sortDirection: newSortDirection, page: 1 },
//         () => {
//             // Trigger export with updated sort criteria
//             this.exportReport(this.state.type, 1, field, newSortDirection);
//         }
//     );
// };
handleSorting = (field) => {
  const { sortField, sortDirection, reportType, processType, prevReportType, prevProcessType } = this.state;

  // Check if the reportType or processType has changed
  const isTypeChanged = reportType !== prevReportType || processType !== prevProcessType;

  // If reportType or processType has changed, reset sortDirection to null
  const newSortDirection = isTypeChanged ? "asc" : (sortField === field && sortDirection === "asc" ? "desc" : "asc");

  // Update the state with the new sorting field and direction
  this.setState(
      {
          sortField: field,
          sortDirection: newSortDirection,
          prevReportType: reportType, // Update the previous reportType for next comparison
          prevProcessType: processType, // Update the previous processType for next comparison
          page: 1, // Reset to the first page for new sorting
      },
      () => {
          // Trigger exportReport only for specific report types
         
              this.exportReport(this.state.type, 1, field, newSortDirection);
          
      }
  );
};


  handleCheckBox = (name, value, index) => {
    let { fabricReportList } = this.state
    if (name === "all") {
      fabricReportList = fabricReportList.map((data, i) => {
        data[`checkbox` + i] = value
        return data
      })
      this.setState({ fabricReportList, all: value })
    } else {
      fabricReportList[index][name] = value
      this.setState({ fabricReportList, all: false })
    }
  }
  saveProcessUpdates = () => {
    let ids = this.state.fabricReportList.reduce((a, c, i) => {
      if (c[`checkbox${i}`]) {
        a.push(c["SR NO"]._id)
      }
      return a
    }, [])
    let obj = {
      requestKey: this.state.requestKey,
      requestValue: this.state.requestValue,
      ids,
      processType: this.state.processType
    }
    return ReportServices.bulkUpdateProcess({ ...obj }).then(response => {
      if (response.status === 200) {
        this.props.getalertMessage("success", response.message)
        return this.exportReport(false, 1)
      }
      response.status == 401 && this.props.unauthorisedFunc()
      response.status == 400 && this.props.getalertMessage("error", response.text.message)
    })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  render() {
    const {
      type,
      reportTypeOption,
      supplierOption,
      requirement,
      requirementOption,
      fabricReportList,
      status,
      progress,
      sampleType,
      sampleTypeOptions,
      styleType,
      styleTypeValue,
      header,
      body,
      arrayValue
    } = this.state;

    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
        <div className={`right-section bg-white`} id="reportId">
          <div class="row nopadding bg-white" id="formId">
            <div class="col-md-12 px-0 py-1">
              <div className="col-md-4 nopadding text-left">
                <span
                  className="p-2 cursor-hover"
                  onClick={e => this.props.history.goBack()}
                >
                  <i className="fa fa-arrow-left" />
                </span>
              </div>
              <div className="col-md-4 nopadding text-center Report-Label">
                <h6>Report</h6>
              </div>
              <div className="col-md-4 ">
                {this.state.type != 'bulkUpdateDispatch' ?
                  <span
                    className="btn-green-icon pull-right"
                    onClick={e => {
                      (this.state.type !== "" && this.exportReport(true)) ||
                        this.props.getalertMessage(
                          "info",
                          "Please Select Report Type"
                        );
                    }}
                  >
                    <img src={download} />
                  </span> : ''}
                {this.state.type != 'bulkUpdateDispatch' ?
                  <span
                    className="btn-green-icon pull-right"
                  >
                    <ReactToPrint
                      trigger={() => <img src={pdfDownload} />}
                      content={() => this.componentRef}
                    />

                  </span> : ''}
              </div>
              <div className="col-md-12">
                <ul className="list-inline text-center justify-content-center">
                  <li>
                    <label>Report Type</label>
                  </li>
                  <li>
                    <Field
                      inputType="select"
                      inputName="type"
                      // className={"p-1 px-3"}
                      value={type}
                      options={reportTypeOption}
                      onChange={this.updateReportType}
                      disabled={false}
                    />
                  </li>
                </ul>
              </div>
              {(() => {
                switch (this.state.type) {
                  case "fabric":
                    return (
                      <FabricForm
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        storeCustomerData={this.storeCustomerData}
                        supplierName={this.state.supplierName}
                        changeSupplierInfo={this.changeSupplierInfo}
                        supplierOption={supplierOption}
                        requirement={requirement}
                        requirementOption={requirementOption}
                        updateState={this.updateState}
                        status={status}
                        statusOptions={statusOptions}
                      />
                    );
                  case "custDept":
                    return (
                      <CustOutstandingForm
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        updateState={this.updateState}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        selectMultipleOption1={this.selectMultipleOption1}
                        arrayValue={this.state.arrayValue}
                        createdAt={this.state.createdAt}
                        storeCustomerData={this.storeCustomerData}
                        typeOfRequest={this.state.typeOfRequest}
                        typeOfRequestOptions={options.typeOfRequest}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        image={this.state.image}
                      />
                    );
                  case "fabPricePending":
                    return (
                      <FabricPricePending
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        updateState={this.updateState}
                        selectMultipleOption1={this.selectMultipleOption1}
                        arrayValue={this.state.arrayValue}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        storeCustomerData={this.storeCustomerData}
                        typeOfRequestOptions={options.typeOfRequest}
                      />
                    );
                  case "sampleProcesses":
                    return (
                      <SampleReportByProcessesForm
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        updateState={this.updateState}
                        arrayValue={this.state.arrayValue}
                        arrayValue1={this.state.arrayValue1}
                        selectMultipleOption={this.selectMultipleOption}
                        selectMultipleOption1={this.selectMultipleOption1}
                        processType={this.state.processType}
                        processTypeOptions={this.state.processTypeOptions}
                        status={status}
                        statusOptions={statusOptions}
                        progress={progress}
                        progressOptions={progressOptions}
                        selectMultipleOption2={this.selectMultipleOption2}
                        arrayValue2={this.state.arrayValue2}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        typeOfRequest={this.state.typeOfRequest}
                        typeOfRequestOptions={options.typeOfRequest}
                        storeCustomerData={this.storeCustomerData}
                      />
                    );
                  case "fabricLibrary":
                    return (
                      <FabricLibrary
                        // customerWithDepartment={
                        //   this.state.customerWithDepartment
                        // }
                        fromDate={this.state.fromDate}
                        updateState={this.updateState}
                        sampleType={sampleType}
                        toDate={this.state.toDate}
                        sampleTypeOptions={sampleTypeOptions}
                        storeCustomerData={this.storeCustomerData}
                        fabNumber={this.state.fabNumber}
                        fabQualityList={this.state.fabQualityList}
                      />
                    );
                  case "sampleLibrary":
                    return (
                      <SampleLibrary
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        updateState={this.updateState}
                        styleType={styleType}
                        styleTypeValue={styleTypeValue}
                        garmentType={this.state.garmentType}
                        itemNo={this.state.itemNo}
                        imageType={this.state.imageType}
                        customerRefNo={this.state.customerRefNo}
                        actionedBy={this.state.actionedBy}
                        actionedByOptions={this.state.actionedByOptions}
                        garmentTypeOptions={this.state.garmentTypeOptions}
                        imageTypeOptions={this.state.imageTypeOptions}
                        storeCustomerData={this.storeCustomerData}
                        exportReport={() => this.exportReport(false, 1)}
                      />
                    );
                  case "dispatch":
                    return (
                      <DispatchForm
                        fromDate={this.state.fromDate}
                        updateState={this.updateState}
                        toDate={this.state.toDate}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        storeCustomerData={this.storeCustomerData}
                        typeOfRequest={this.state.typeOfRequest}
                        typeOfRequestOptions={options.typeOfRequest}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        selectMultipleOption2={this.selectMultipleOption2}
                        arrayValue2={this.state.arrayValue2}
                        location={this.state.location}
                        LOCATION={this.state.LOCATION}
                        courier={this.state.courier}
                        courierOptions={this.state.COURIER}
                        awbNumber={this.state.awbNumber}
                      />
                    );
                  case "bNumber":
                    return (
                      <BNumberForm
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        updateState={this.updateState}
                        storeCustomerData={this.storeCustomerData}
                        countCons={this.state.countCons}
                        bNumber={this.state.bNumber}
                      />
                    );
                  case "bulkUpdateDispatch":
                    return (
                      <BulkUpdateForDispatch
                        getalertMessage={this.props.getalertMessage}
                        updateState={this.updateState}
                        getNumberFrom={this.getNumberFrom}
                        NumberFromList={this.state.NumberFromList}
                        NumberFromObj={this.state.NumberFromObj}
                        getNumberList={this.getNumberList}
                        addNumbers={this.addNumbers}
                        searchBy={this.searchBy}
                        resetBy={this.resetBy}
                        removeNumbers={this.removeNumbers}
                        ids={this.state.ids}
                        toDate={this.state.toDate}
                        awbNumber={this.state.awbNumber}
                        location={this.state.location}
                        LOCATION={this.state.LOCATION}
                        courier={this.state.courier}
                        courierOptions={this.state.COURIER}
                        List={this.state.fabricReportList}
                        printDate={this.state.printDate}
                        exportReport={this.exportReport}
                        bulkDispatchUpdate={this.bulkDispatchUpdate}
                        addDispatchData={this.addDispatchData}
                        dispatchUpdate={this.dispatchUpdate}
                      />
                    );
                  case "processCompleted":
                    return (
                      <ProcessCompletedForm
                        updateState={this.updateState}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        storeCustomerData={this.storeCustomerData}
                        processType={this.state.processType}
                        processTypeOptions={this.state.processTypeOptions}
                        typeOfRequest={this.state.typeOfRequest}
                        typeOfRequestOptions={options.typeOfRequest}
                        completed={this.state.completed}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        selectMultipleOption2={this.selectMultipleOption2}
                        arrayValue2={this.state.arrayValue2}
                      />
                    );
                  case "printYarn":
                    return (
                      <PrintYarnForm
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        storeCustomerData={this.storeCustomerData}
                        supplierName={this.state.supplierName}
                        changeSupplierInfo={this.changeSupplierInfo}
                        supplierOption={supplierOption}
                        requirement={requirement}
                        requirementOption={requirementOption}
                        updateReportType={this.updateReportType}
                        status={status}
                        statusOptions={statusOptions}
                      />
                    );

                  case "processUpdates": //Sample Awaiting Materials
                    return (
                      <ProcessUpdatesForm
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}

                        updateState={this.updateState}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        // processUpdatesETA={this.state.processUpdatesETA}
                        storeCustomerData={this.storeCustomerData}
                        processType={this.state.processType}
                        processTypeOptions={this.state.processTypeOptions}
                        typeOfRequest={this.state.typeOfRequest}
                        typeOfRequestOptions={options.typeOfRequest}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        selectMultipleOption2={this.selectMultipleOption2}
                        arrayValue2={this.state.arrayValue2}
                      />
                    );
                  case "patternMasterReport":
                    return (
                      <PatterMasterReport
                        updateState={this.updateState}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        patternMasterList={this.state.patterMasterList}
                        storeCustomerData={this.storeCustomerData}
                        typeOfRequest={this.state.typeOfRequest}
                        typeOfRequestOptions={options.typeOfRequest}
                        completed={this.state.completed}
                        patternMaster={this.state.patternMaster}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        selectMultipleOption2={this.selectMultipleOption2}
                        arrayValue2={this.state.arrayValue2}
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                      // updatePatternMaster={this.updateState}
                      />
                    );
                  case "bulkUpdateProcess":
                    return (
                      <BulkProcessUpdates
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}

                        updateState={this.updateState}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        // processUpdatesETA={this.state.processUpdatesETA}
                        storeCustomerData={this.storeCustomerData}
                        processType={this.state.processType}
                        processTypeOptions={this.state.processTypeOptions}
                        typeOfRequest={this.state.typeOfRequest}
                        typeOfRequestOptions={options.typeOfRequest}
                        sampleType={sampleType}
                        sampleTypeOptions={sampleTypeOptions}
                        selectMultipleOption2={this.selectMultipleOption2}
                        arrayValue2={this.state.arrayValue2}
                        requestValue={this.state.requestValue}
                        requestKey={this.state.requestKey}
                        STATUS={this.state.STATUS}
                        list={this.state.fabricReportList}
                        showForm={this.state.showForm}
                        saveProcessUpdates={this.saveProcessUpdates}
                        all={this.state.all}
                      />
                    );
                  case "styleDownloads":
                    return (
                      <StyleDownloads
                        updateState={this.updateState}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        storeCustomerData={this.storeCustomerData}
                        completed={this.state.completed}
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        actionedByOptions={this.state.actionedByOptions}
                        actionedBy={this.state.actionedBy}
                      />
                    );
                  case "sampleRequestDownloads":
                    return (
                      <StyleDownloads
                        updateState={this.updateState}
                        customerWithDepartment={
                          this.state.customerWithDepartment
                        }
                        storeCustomerData={this.storeCustomerData}
                        completed={this.state.completed}
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                      />
                    );
                  default:
                    return null;
                }
              })()}
              {this.state.type != 'bulkUpdateDispatch' ?
                <div
                  className={`col-md-12 text-center mt-2 ${!this.state.type ? "d-none" : ""
                    }`}
                >
                  {(this.state.type !== "bulkUpdateProcess" || this.state.showForm) && <div className="col-md-12">
                    <button
                      class="primary"
                      onClick={e => {
                        // Reset sortField and sortDirection to null before generating the report
                        this.setState({ sortField: null, sortDirection: null, page: 1 }, () => {
                          // Call exportReport with the reset values
                          this.exportReport(false, 1);
                        });
                      }}
                    >
                      generate report
                    </button>
                  </div>}
                  {this.state.type !== 'bulkUpdateProcess' && <div className="col-md-6 col-md-offset-2 text-center  mt-3">
                    <div className="col-md-9 mt-1">
                      <input
                        type="email"
                        placeholder="Enter an Email..."
                        className="form-control ml-2 border-1"
                        onChange={e => {
                          this.setState({ emailId: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-3 ">
                      <button
                        className="primary"
                        disabled={this.state.emailId.length > 0 ? false : true}
                        onClick={e => this.exportReport("sendEmail")}
                      >
                        send email
                      </button>
                    </div>
                  </div>}
                </div>

                : ''}</div>
            {this.state.type === "sampleLibrary" && <div class="col-md-12 pull-right">
              <div className="col-md-4 pull-right d-flex new-paginamtion-align">
                {(this.state.generateCount && this.state.generateCount !== 1) && <div>
                  <button
                    className="primary"
                    // disabled={this.state.emailId.length > 0 ? false : true}
                    onClick={e => this.generatePage(0)}
                  >
                    &#60;&#60;
                  </button>
                  <button
                    className="primary"
                    // disabled={this.state.emailId.length > 0 ? false : true}
                    onClick={e => this.generatePage(this.state.userPageInput - 1)}
                  >
                    &#60;
                  </button>
                </div>
                  || ""}
                <p className="text-right d-flex page-text">
                  Page
                  <input
                    type="number"
                    // placeholder="Enter page no..."
                    className="form-control ml-2 border-1"
                    onChange={e => {
                      this.setState({ userPageInput: Number(e.target.value) });
                    }}
                    value={this.state.userPageInput}
                  />
                  of {this.state.count}
                </p>
                {this.state.count > this.state.generateCount && <div>
                  <button
                    className="primary"
                    // disabled={this.state.emailId.length > 0 ? false : true}
                    onClick={e => this.generatePage(this.state.generateCount + 1)}
                  >
                    &#62;
                  </button>
                  <button
                    className="primary"
                    // disabled={this.state.emailId.length > 0 ? false : true}
                    onClick={e => this.generatePage(this.state.count)}
                  >
                    &#62;&#62;
                  </button>
                </div>}
                <button
                  className="primary"
                  // disabled={this.state.emailId.length > 0 ? false : true}
                  onClick={e => this.generatePage(this.state.userPageInput || 1)}
                >
                  Go
                </button>
              </div>
            </div>}
          </div>
          <div
            className={
              ((fabricReportList.length || body.length) &&
                "row nopadding bg-white d-flex justify-content-center") ||
              "d-none"
            }
          >
            <div className="w-100">
              <table
                id="report-list-height"
                className="report-list-height mt-5"
                onScroll={this.state.type !== 'sampleLibrary' && this.handleScroll}
              >
                {this.state.type === "fabric" && (
                  <tr>
                    {fabricReportList !== undefined &&
                      fabricReportList.length > 0 &&
                      Object.keys(fabricReportList[0]).map(data => {
                        if (data !== "ID")
                          return <td className="report-header">{data}</td>;
                      })}
                  </tr>
                )}
                {this.state.type === "dispatch" && (
                  <Dispatch
                    list={fabricReportList}
                    displayData={this.displayData}
                  />
                )}
                {this.state.type === "bNumber" && (
                  <BNumberList
                    list={fabricReportList}
                    right={this.props.rights.bNumber}
                  />
                )}
                {this.state.type === "fabPricePending" && (
                  <FabricPricePendingList
                    rights={this.props.rights.fabPricePending}
                    styleRights={this.props.styleRights}
                    list={fabricReportList}
                    processType={this.state.processType}
                    history={this.props.history}
                  />
                )}
                {this.state.type === "fabricLibrary" && (
                  <FabricLibraryList
                    rights={this.props.rights.fabricLibrary}
                    styleRights={this.props.styleRights}
                    modalData={this.modalData}
                    list={fabricReportList}
                    processType={this.state.processType}
                    history={this.props.history}
                  />
                )}
                {this.state.type === "sampleProcesses" && (
                  <SampleReportByProcessesList
                    rights={this.props.rights.sampleProcesses}
                    styleRights={this.props.styleRights}
                    sampleRights={this.props.sampleRequest}
                    modalData={this.modalData}
                    list={body}
                    processType={this.state.processType}
                    history={this.props.history}
                    disabled={this.state.disabled}
                    header={header}
                    showHeaders={arrayValue}
                  />
                )}
                {this.state.type === "sampleLibrary" && (
                  <SampleLibraryList
                    rights={this.props.rights.sampleLibrary}
                    styleRights={this.props.styleRights}
                    modalData={this.modalData}
                    list={fabricReportList}
                    processType={this.state.processType}
                    history={this.props.history}
                  />
                )}
                {this.state.type === "processCompleted" && (
                  <ProcessCompletedList
                    rights={this.props.rights.processCompleted}
                    styleRights={this.props.styleRights}
                    sampleRights={this.props.sampleRequest}
                    list={fabricReportList}
                    processType={this.state.processType}
                    history={this.props.history}
                  />
                )}
                {this.state.type === "printYarn" && (
                  <PrintYarnList
                    list={fabricReportList}
                    state={this.state}
                    modalData={this.modalData}
                    rights={this.props.rights.printYarn}
                    styleRights={this.props.styleRights}
                  />
                )}
                {(this.state.type === "processUpdates" || this.state.type === "bulkUpdateProcess") && ( // sample awaiting material
                  <ProcessUpdatesList
                    type={this.state.type}
                    rights={this.props.rights.processUpdates}
                    styleRights={this.props.styleRights}
                    sampleRights={this.props.sampleRequest}
                    list={fabricReportList}
                    processType={this.state.processType}
                    history={this.props.history}
                    sorting={this.handleSorting}
                    handleCheckBox={this.handleCheckBox}
                    all={this.state.all}
                  />
                )}
                {/* {this.state.type === "bulkUpdateDispatch" && (
                <BulkUpdateForDispatchList
                  rights={this.props.rights.processUpdates}
                  styleRights={this.props.styleRights}
                  list={fabricReportList}
                  processType={this.state.processType}
                  history={this.props.history}
                />
              )} */}
                {this.state.type === "fabric" &&
                  fabricReportList !== undefined &&
                  Array.isArray(fabricReportList) &&
                  fabricReportList.length > 0 &&
                  fabricReportList.map((data, index) => (
                    <tr>
                      {Object.keys(data).map(dat => {
                        if (dat == "IMAGE" && data[dat] != "") {
                          return (
                            <td>
                              <img
                                src={`${data[dat]}`}
                                style={{ width: " 50px", height: "50px" }}
                              />
                            </td>
                          );
                        } else if (
                          dat == "DEV REF NUMBER" ||
                          dat == "FABRIC REF NO"
                        ) {
                          if (
                            this.props.rights.fabric.web.edit ||
                            this.props.rights.fabric.web.view
                          ) {
                            return (
                              <td>
                                <p
                                  className="under-line cursor-hover"
                                  // let stylePage = listValue => {
                                  //   let action =
                                  //     (props.styleRights.web.edit && "edit") ||
                                  //     (props.rights.web.view && "view");
                                  //   let newSearch = "?" + new URLSearchParams({
                                  //     action: action,
                                  //     _id: listValue._id,
                                  //     hash: `seleted${listValue.referenceCode.split("-").join("")}`
                                  //   }).toString()
                                  //   window.open(`/StylePage${newSearch}#seleted${listValue.referenceCode.split("-").join("")}`, "_blank")

                                  // };
                                  onClick={() => {
                                    let action =
                                      (this.props.styleRights.web.edit && "edit") ||
                                      (this.props.rights.web.view && "view");
                                    let newSearch = "?" + new URLSearchParams({
                                      action: action,
                                      _id: data.ID,
                                      // hash: `seleted${listValue.code.split("-").join("")}`
                                    }).toString()
                                    window.open(`/developmentFabric${newSearch}`, "_blank")
                                    // window.open(`/StylePage${newSearch}`, "_blank")
                                  }
                                    // this.props.history.push(
                                    //   "/developmentFabric",
                                    //   {
                                    //     action:
                                    //       this.props.rights.fabric.web.edit ==
                                    //         true
                                    //         ? "edit"
                                    //         : this.props.rights.fabric.web.view
                                    //           ? "view"
                                    //           : "",
                                    //     _id: data.ID,
                                    //     report: { ...this.state },
                                    //     route: "Report"
                                    //   }
                                    // )
                                  }
                                >
                                  {data[dat]}
                                </p>
                              </td>
                            );
                          } else {
                            return (
                              <td>
                                <p>{data[dat]}</p>
                              </td>
                            );
                          }
                        } else if (dat != "ID") {
                          return <td>{data[dat]}</td>;
                        }
                      })}
                    </tr>
                  ))}
                {this.state.type === "custDept" && body && body.length > 0 && (
                  <CustOutstand
                    state={this.state}
                    list={body}
                    header={header}
                    history={this.props.history}
                    rights={this.props.rights}
                    getalertMessage={this.props.getalertMessage}
                    changeBg={this.changeBg}
                    setTitle={this.setTitle}
                    modalData={this.modalData}
                  />
                )}
                {this.state.type === "patternMasterReport" && (
                  <PatterMasterReportList
                    rights={this.props.rights.processCompleted}
                    styleRights={this.props.styleRights}
                    sampleRights={this.props.sampleRequest}
                    list={fabricReportList}
                    processType={this.state.processType}
                    history={this.props.history}
                  />
                )}
                {(this.state.type === "styleDownloads" || this.state.type === "sampleRequestDownloads") && (
                  <StyleDownloadsList
                    rights={this.props.rights.processCompleted}
                    sampleRights={this.props.sampleRequest}
                    styleRights={this.props.styleRights}
                    list={fabricReportList}
                    processType={this.state.processType}
                    history={this.props.history}
                  />
                )}
              </table>

            </div>
          </div>
          <div style={{ display: "none" }}>
            <PrintTable
              fabricReportList={fabricReportList}
              body={body}
              header={header}
              arrayValue={arrayValue}
              ref={el => (this.componentRef = el)}
              type={this.state.type}
            />
          </div>
        </div>
        <Modal
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
          s
          center
        >
          {this.state.filePreviewIframe}
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    rights: state.main.rights.reports,
    styleRights: state.main.rights.style,
    sampleRequest: state.main.rights.sampleRequest,
    fabric: state.main.rights.fabric
  };
};

export default connect(mapStateToProps, null)(Report);


// WEBPACK FOOTER //
// ./src/pages/report/page.js